/**
 * Created by mestrad on 2018. 08. 08..
 */

export default Suggestion;
import AjaxRequest from './Ajax';

const $ = jQuery;

const namespaceMapping = {
    'foldrajzi-nevter': 'geo',
    'szemelyi-nevter': 'person',
    'testuleti-nevter': 'corporate',
    'emlekhelyi-nevter': 'memorial'
}

const getParams = () => new URLSearchParams(window.location.search);
/**
 * @returns {String|null}
 */
const getId = () => getParams().get('id');
const getPathArray = () => window.location.pathname.split('/');
/**
 * @returns {String}
 */
const getNamespace = () => {
    const elementsOfPath = getPathArray();
    const match = Object.keys(namespaceMapping).find(key => elementsOfPath.includes(key));
    return match ? namespaceMapping[match] : '';
}


function Suggestion(config) {
    var dialog;
    var form;
    var name;
    var email;
    var phoneNumber;
    var suggestionText;
    var allFields;
    init();

    function init() {
        name = $(config.domElements.suggestionName);
        email = $(config.domElements.suggestionEmail);
        phoneNumber = $(config.domElements.suggestionPhoneNumber);
        suggestionText = $(config.domElements.suggestionText);
        phoneNumber.inputmask('+36 (99) 999 9999');
        allFields = $([]).add(name).add(email).add(phoneNumber).add(suggestionText);
        dialog = $(config.domElements.suggestionFormContainer).dialog({
            autoOpen: false,
            height: 500,
            width: 500,
            modal: true,
            buttons: {
                'Küldés': sendSuggestion,
                'Bezárás': function () {
                    dialog.dialog('close');
                },
            },
            close: function () {
                form[0].reset();
                allFields.removeClass('ui-state-error');
            },
        });
        initEvents();
        openSuggestionDialog();
    }

    function initEvents() {
        form = dialog.find('form').on('submit', function (event) {
            event.preventDefault();
            sendSuggestion();
        });
    }

    function openSuggestionDialog() {
        dialog.dialog('open');
    }

    function validateForm() {
        var valid = false;
        var emailRegex = /^.+[@].+[.].+$/;

        allFields.removeClass('ui-state-error');
        valid = checkRegexp(email, emailRegex);
        if (suggestionText.val().length >= 5) valid = valid && true;
        return valid;
    }

    function checkRegexp(item, regexp) {
        if (!(regexp.test(item.val()))) {
            item.addClass('ui-state-error');
            return false;
        }
        return true;
    }

    function sendSuggestion() {
        if (validateForm()) {
            var request = {
                url: config.ajaxUrl + '/proposal',
                action: 'proposal',
                data: {
                    email: encodeURI(email.val()),
                    text: encodeURI(suggestionText.val()),
                    identifier: getId(),
                    namespace: getNamespace(),
                },
            };
            if (name.val() !== '') Object.assign(request.data, {name: encodeURI(name.val())});
            if (phoneNumber.val() !== '') Object.assign(request.data,
                {phone_number: encodeURI('+36' + phoneNumber.inputmask('unmaskedvalue'))});

            AjaxRequest(request);
            phoneNumber.inputmask('remove');
            dialog.dialog('close');
        }
    }

}